// extracted by mini-css-extract-plugin
export default {"Flag":"Flag_Flag__9Y+td"};